import {
  apply,
  call,
  put,
  select,
  takeEvery
}                                 from 'redux-saga/effects';
import service                    from "../../services";
import { Routes }                 from "../../types";
import { setBookmarks }           from "../bookmarks/actions";
import {
  bwsAddCameraBookmarks,
  bwsAddTimeStrips
}                                 from "../browse/actions";
import onError                    from './onErrorSaga';
import { chooseServiceGenerator } from "./utils";

function* errorHandler(error) {
  yield onError('Bookmarks failed... ' + error);
}

function* getOcularisBookmarks() {
  const {token} = yield select(state => state.API);

  try {
    const {data} = yield apply(service, service.getBookmarks, [token]);

    try {
      data.bookmarks.forEach(d => d.duration = d.stop - d.start);
    } catch (e) {
    }

    if (data.bookmarks)
      yield put(setBookmarks(data.bookmarks));
  } catch (e) {
    const {pathname} = yield select(state => state.router.location);
    if (pathname === Routes.bookmarks)
      yield call(errorHandler, e.response);
  }
}

function* getCayugaBookmarks(action) {
  const {token} = yield select(state => state.API);
  const {pane} = action;
  const {browsePanes} = yield select(state => state.browse);
  const camId = browsePanes?.[pane]?.id;
  const strips = browsePanes?.[pane]?.timestrips.filter(s => s.type !== 5 && s.type !== 0);
  const min = Math.min.apply(null, strips.map(item => item.low)),
    max = Math.max.apply(null, strips.map(item => item.high));

  try {
    const {data, error} = yield apply(service, service.getBookmarks, [token, camId, min, max]);
    if (error) {
      return yield call(errorHandler, data);
    }
    if (data['a:BookmarkEntityInfo']) {
      const bookmarks = Array.isArray(data['a:BookmarkEntityInfo'])
        ? data['a:BookmarkEntityInfo']
        : [data['a:BookmarkEntityInfo']];
      const strips = bookmarks.map(bkm => ({
        low: parseInt(bkm['a:Timestamp']),
        high: parseInt(bkm['a:Timestamp']),
        type: 0
      }));

      yield put(bwsAddCameraBookmarks(pane, bookmarks));
      yield put(bwsAddTimeStrips(pane, strips, 'bkmks'));
    }
  } catch (e) {
    yield call(errorHandler, e);
  }
}

export default function* () {
  yield takeEvery('getBookmarks', chooseServiceGenerator,
    {fn: getOcularisBookmarks, args: []},
    {fn: getCayugaBookmarks, args: []}
  );
}
